import {
	Component,
	EventEmitter,
	Input,
	Output,
	OnInit,
	ViewChild,
	OnChanges,
} from "@angular/core";
import {
	animate,
	state,
	style,
	transition,
	trigger,
} from "@angular/animations";

import { EntityManagerProvider } from "../../../providers/entity-manager-provider/entity-manager-provider";
import { SeccionPlano, PlanoComponent } from "interiores-mapa";
import { zoomCenterCoordsPlano } from "interiores-mapa/dist/zoomCenterCoordsPlano";
import { ServiciosWebServiceProvider } from "../../../providers/web-service-service/servicios-web-service";
import { AuthenticationService } from "../../../providers/authentication/authentication.service";
import { AlaFormulario } from "../../../domain/AlaFormulario";
import { Planta, VerticalManager } from "../../../domain/Vertical";
import { Predicate } from "breeze-client";


type PaneType = "left" | "right";

const COLORES2 = [
	[255, 14, 240],
	[255, 160, 0],
	[5, 0, 255],
];

const COLORES = [
	[255, 0, 20],
	[215, 255, 0],
	[5, 0, 255],
];

@Component({
	selector: "app-hotchart",
	templateUrl: "./hotChart.component.html",
	styleUrls: ["./hotChart.component.scss"],
	animations: [
		trigger("side1", [
			state("left", style({ opacity: 0 })),
			state("center", style({ opacity: 1 })),
			state("right", style({ opacity: 0 })),

			transition("left <=> center", [animate("200ms ease-in")]),
			transition("center <=> right", [animate("200ms ease-in")])
		]),
	],
	providers: [EntityManagerProvider],
})
export class AppHotChartComponent implements OnInit, OnChanges {
	@Input() data;
	@Input() consulta;
	@Input() mensaje;
	// @Input() mostrarIconoMaximizar;
	@Input() numAla = 0;
	@Input() numTipo = 0;
	@Output() onChangeRange: EventEmitter<any> = new EventEmitter();
	@Output() onLoadSecciones: EventEmitter<any> = new EventEmitter();
	@Output() onDownloadCsv: EventEmitter<any> = new EventEmitter();
	@ViewChild("plano") plano: PlanoComponent;
	@ViewChild("contenedorPlano") contenedorPlano: any;
	// @Output() maximizeHotChartEvent = new EventEmitter<boolean>();
	@Output() maximizeHotChartEvent: EventEmitter<any> = new EventEmitter();

	estado = "center";

	pathPlano = "";

	alas = [];
	secciones = [];
	seccionesPre = [];
	verticalManager: VerticalManager;
	mostrarIconoMaximizar = true;

	// numAla = 0; // Para seleccionar el plano que se pinta.
	// numTipo = 0; // Para seleccionar el periodo en el que se cuentan las visitas
	numModo = 0; // Para seleccionar si se cuentan las visitas por número de visitas o por tiempo de visita.

	maxRange = 0;

	planoData = {
		width: 0,
		height: 0,
	};

	alasDrop = [];
	tiposDrop = [
		{ label: "Visitas", value: 0 },
		{ label: "Permanencia", value: 1 },
		{ label: "Visitas X Permanencia", value: 2 },
	];
	modosDrop = [
		{ label: "Número de visitas", value: 0 },
		{ label: "Tiempo de visita", value: 1 },
	];
	alasSelect;
	rangoFechasSeleccionado;

	mostrarSecciones = true;
	alaCargada = false;

	direccion = 1;

	seccionesHot: any = {};

	currentZoomLevel: number = 1;

	zoomAndCenterCoords: zoomCenterCoordsPlano;
	zoomCenterTransitionDuration: Number = 1000;

	zoomIniciado = false;

	plano_current_transform: any = {};
	save_zoom_event: any = false;

	//  Añadido 27/027/2020: Variables para el nuevo mapa de calor
	puntos = [];
	radius = 250;
	opacity = 0.5;
	scale = 0.3;
	useOpacity = true;
	//  FIXME: Estas variables se han de obtener de base de datos en donde viene el tamaño del mapa.
	anchoMapa = 4000;
	altoMapa = 4000;
	listaAlasFormulario = [];

	nodosDeLaConsulta = [];

	constructor(
		public sws: ServiciosWebServiceProvider,
		public authenticationService: AuthenticationService,
		private entityManagerProvider: EntityManagerProvider,
		public authService: AuthenticationService
	) {}

	setRadius(IconoContenidoScale) {
		this.radius = this.radius * IconoContenidoScale * 0.8;
	}
	setScale(contenedorPlano, anchoMapa) {
		// return (contenedorPlano.offsetWidth - 30) / anchoMapa;
		let scale = 1;
		if (this.altoMapa > this.anchoMapa) {
			const num = (contenedorPlano.offsetHeight - 30) / this.altoMapa;
			// Redondeamos a dos cifras para que no se queje HTML de que el valor cambia al usar muchos decimales y las ultimas cifras siempre varian
			scale = Math.round((num + Number.EPSILON) * 100) / 100;
		} else {
			const num = (contenedorPlano.offsetWidth - 30) / this.anchoMapa;
			// Redondeamos a dos cifras para que no se queje HTML de que el valor cambia al usar muchos decimales y las ultimas cifras siempre varian
			scale = Math.round((num + Number.EPSILON) * 100) / 100;
		}
		// console.log('Scale: ' + scale);
		return scale;
	}

	OnChanges($event) {
		this.cargaSecciones();
	}

	onZoomChanged(zoomChange) {
		if (this.zoomIniciado) {
			this.saveZoom(zoomChange);
		}
	}

	saveZoom(zoomChange) {
		const _key = "MAPPOS_" + this.alas[this.numAla];
		localStorage.setItem(_key, JSON.stringify(zoomChange));
	}

	setCurrentTransform() {
		const _key = "MAPPOS_" + this.alas[this.numAla];
		const dat = localStorage.getItem(_key);

		let current: any = {};
		if (dat) {
			current = JSON.parse(dat);
		}

		if (!current.k) {
			return;
		}

		const _width = this.planoData.width; //  DCANETE Revisar W
		const _height = this.planoData.height; //  DCANETE Revisar H

		this.zoomAndCenterCoords = new zoomCenterCoordsPlano(
			0,
			0,
			0,
			0,
			current.k,
			[_width / 2, _height / 2]
		);
	}

	onChangeRangeApp(change) {
		this.rangoFechasSeleccionado = change;
		this.numTipo = change.numTipo;
		change.numModo = this.numModo;
		// console.log('---------- onChangeRangeApp valor de change: ');
		// console.log(change);
		this.onChangeRange.emit(change);
	}

	public cambiarModo(res) {
		this.numModo = res.value;
		this.rangoFechasSeleccionado.numModo = res.value;
		this.rangoFechasSeleccionado.numTipo = this.numTipo;
		// console.log('---------- cambiarModo valor de rangoFechasSeleccionado: ');
		// console.log(this.rangoFechasSeleccionado);
		this.onChangeRange.emit(this.rangoFechasSeleccionado);
	}

	redondeo(num) {
		return Math.floor(num);
	}

	downloadCSV(event) {
		this.onDownloadCsv.emit(event);
	}

	maximizeHotChart() {
		this.mostrarIconoMaximizar = false;
		const valoresSeleccionadosHotChart = {
			pathPlano: this.pathPlano,
			numAla: this.numAla,
			numTipo: this.numTipo,
			numModo: this.numModo,
		};
		this.maximizeHotChartEvent.emit(valoresSeleccionadosHotChart);
	}

	minimizeHotChart() {
		this.mostrarIconoMaximizar = true;
		const valoresSeleccionadosHotChart = {
			pathPlano: this.pathPlano,
			numAla: this.numAla,
			numTipo: this.numTipo,
			numModo: this.numModo,
		};
		this.maximizeHotChartEvent.emit(valoresSeleccionadosHotChart);
	}

	ngOnInit() {
		this.cargarALAs("ngOnInit");

		this.numAla = 0;
		this.numModo = 0;
		this.zoomIniciado = false;
		const hoy = new Date();
		const inicioAux = new Date(
			hoy.getFullYear(),
			hoy.getMonth(),
			1,
			hoy.getHours(),
			hoy.getMinutes()
		);
		const finAux = new Date(
			hoy.getFullYear(),
			hoy.getMonth() + 1,
			0,
			hoy.getHours(),
			hoy.getMinutes()
		);
		this.rangoFechasSeleccionado = {
			inicio: inicioAux,
			fin: finAux,
			lastMinutes: 0,
			numTipo: 0,
			numModo: 0,
		};
	}

	ngOnChanges(change) {
		this.cargaSecciones();
		this.zoomIniciado = false;
	}

	pickHex(weight) {
		let color1 = COLORES[0];
		let color2 = COLORES[1];
		let multi = 1;
		if (weight < 0.5) {
			color1 = COLORES[1];
			color2 = COLORES[2];
			multi = 2;
		}

		const w1 = weight * multi;
		const w2 = 1 - w1;

		const rgb = [
			Math.round(color1[0] * w1 + color2[0] * w2),
			Math.round(color1[1] * w1 + color2[1] * w2),
			Math.round(color1[2] * w1 + color2[2] * w2),
		];

		return "rgba(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + ",0.8)";
	}

	cargaSecciones() {
		console.log('cargaSecciones');
		let max = 0;
		let all = 0;

		this.seccionesHot = {};

		if (!this.consulta) {
			return;
		}

		this.consulta.forEach((element) => {
			this.seccionesHot[element.Seccion] = {
				Total: element.Total,
			};

			all += element.Total;
			if (max < element.Total) {
				max = element.Total;
			}
		});

		this.maxRange = max;

		this.consulta.forEach((element) => {
			const perc = Math.floor((element.Total * 100) / max);
			const percAll = Math.floor((element.Total * 100) / all);
			this.seccionesHot[element.Seccion]["percentageAll"] = percAll;
			this.seccionesHot[element.Seccion]["percentage"] = perc;
			this.seccionesHot[element.Seccion]["color"] = this.pickHex(
				perc / 100
			);
		});

		this.nodosDeLaConsulta = [];
		this.consulta.forEach((element) => {
			this.nodosDeLaConsulta.push(element);
		});

		// this.cargarALAs("cargaSecciones");
		this.cargarSeccionAux();
	}

	getZoomStart() {
		// console.log(this.alas);
	}

	cargarALAs(id: String) {
		console.log("cargarALAs: ", id);
		this.puntos = [];
		const that = this;
		const entityManager = that.entityManagerProvider;
		const idEspacio = that.authService.getIdEspacio();
		const predicado = new Predicate("IdEspacio", "==", idEspacio);
		let includes = "";
		includes = includes + "SECCIONS.NODOS";
		includes = includes + ", NIVEL";
		let includes2 = "ESPACIO";
		includes2 = includes2 + ", IDIOMAS.IDIOMA";
		includes2 = includes2 + ", ALAS.IDIOMAS.IDIOMA";
		//includes2 = includes2 + ', SECCIONS.NODOS';
		let listaNiveles;
		let ENT = [];
		let plantas = [];
		let planta = new Planta();
		if (!this.verticalManager) {
			this.verticalManager = new VerticalManager();
		}
		const alaActual = this.listaAlasFormulario[this.numAla];
		let idAlaActual;
		if (id === "cargaSecciones") {
			idAlaActual = alaActual.Id;
			this.setRadius(alaActual.IconoContenidoScale);
		}
		if (id === "ngOnInit") {
			idAlaActual = undefined;
		}

		return entityManager
			.getALAById(idAlaActual, includes)
			.then(function (entidades) {
				if (!entidades || entidades.length < 1) {
				} else {
					let i = 0;

					if (id === "ngOnInit") {
						that.alasDrop = [];
					}
					const _seccionesFormat = {};
					//ordenadas alas alfabeticamente
					/*entidades.sort(function (a, b) {
          return a.Nomobre.localeCompare(b.Nomobre);
        });*/

					entidades.forEach((element) => {
						const oAlaForm = new AlaFormulario(element);
						//entityManager.getALAById(oAlaForm.Id, includes);
						// Modificado Jeronimo 14/04/2020: Antes de cargar las alas en listaAlasFormulario, busco si el ala ya está en esa lista y si ya está no la vuelvo a añadir.
						const alaEncontradaAux = that.listaAlasFormulario.find(
							(a) => a.Id === oAlaForm.Id
						);
						if (alaEncontradaAux) {
							// No hago nada.
						} else {
							that.listaAlasFormulario.push(oAlaForm);
						}

						// that.listaAlasFormulario.push(oAlaForm);
						if (id === "ngOnInit") {
							that.alas.push(element.RutaImagen);
							that.seccionesPre.push(element.SECCIONS);
							that.alasDrop.push({
								label: element.Nomobre,
								value: i,
								nivel: element.NIVEL.NivelVertical,
							});
						}
						that.alasDrop.sort(function (a, b) {
							if (a.nivel === b.nivel) {
								return a.label.localeCompare(b.label);
							}
							return a.nivel - b.nivel;
						});
						element.SECCIONS.forEach((_sec) => {
							_seccionesFormat[_sec.Id] = {
								nombre: _sec.Nombre,
							};

							_sec.NODOS.forEach((_nod) => {
								// x sería el índice del elemento en el array de nodosDeLaConsulta
								let enc = false;
								let x = 0;
								const tam = that.nodosDeLaConsulta.length;
								while (x < tam && !enc) {
									if (
										_nod.Id ===
										that.nodosDeLaConsulta[x].Nodo
									) {
										enc = true;
									} else {
										x = x + 1;
									}
								}
								if (enc) {
									const point = {
										id: _nod.Id,
										x: _nod.X,
										y: _nod.Y,
										value: that.nodosDeLaConsulta[x].Total,
									};
									that.puntos.push(point);
								}
							});
						});

						i++;
					});

					// console.log('DATOS DE LOS PUNTOS DE LOS NODOS A MOSTRAR EN EL MAPA:');
					// console.log(that.puntos);

					that.puntos = Object.assign([], that.puntos);

					that.onLoadSecciones.emit(_seccionesFormat);
				}
				// Fin Else

				//  that.addSecciones(0);
				const alaNueva = that.alas[that.numAla];

				if (alaNueva === that.pathPlano) {
					//  Si NO hemos cambiado de ala añadimos las secciones del Ala actualpor si estas han cambiado
					that.addSecciones(that.numAla);
				} else {
					//  Si hemos cambiado de ala seteamos that.pathPlano que deipara cargarAla -> onSVGLoaded -> CargarSecciones
					that.pathPlano = alaNueva;
				}
				that.setCurrentTransform();
				setTimeout(function () {
					that.zoomIniciado = true;
				}, 2000);
				const token = that.authenticationService.getToken();
				const idEspacio = that.authenticationService.getIdEspacio();
				return that.sws
					.wsGetGeocalibracionAlasEspacio(token, idEspacio)
					.toPromise();
			})
			.then(function (resp: any) {
				console.log("GEOCALIBRACION_ALA: ", resp.GeocalibracionAlas);
				that.listaAlasFormulario.forEach((ala) => {
					const aux = resp.GeocalibracionAlas.find(
						(g) => g.IdAla === ala.Id
					);
					ala.GEOCALIBRACION_ALA = aux;
				});
				
				let alaSeleccionada = that.listaAlasFormulario.find(
					(a) => a.RutaImagen === that.alas[that.numAla]
				);

				if(alaSeleccionada.GEOCALIBRACION_ALA === undefined){
					alaSeleccionada = that.listaAlasFormulario.find(a => a.GEOCALIBRACION_ALA !== undefined)
				}

				that.anchoMapa =
					alaSeleccionada.GEOCALIBRACION_ALA !== undefined
						? alaSeleccionada.GEOCALIBRACION_ALA.SVG_width
						: that.anchoMapa;
				that.altoMapa =
					alaSeleccionada.GEOCALIBRACION_ALA !== undefined
						? alaSeleccionada.GEOCALIBRACION_ALA.SVG_height
						: that.altoMapa;
				console.log("Ancho: ", that.anchoMapa, "Alto: ", that.altoMapa);
				if (alaSeleccionada.GEOCALIBRACION_ALA === undefined) {
					console.error(
						"No existe GEOCALIBRACION_ALA para este ALA: " +
							alaSeleccionada.id +
							", si se quiere que el plano se vea bien ha de insertarse en base de datos una GEOCALIBRACION_ALA minimo con SVG_width y SVG_height"
					);
				}
			});
	}

	cargarSeccionAux() {
		console.log("cargarSeccionAux");
		this.puntos = [];
		const that = this;
		const _seccionesFormat = {};

		if (!this.verticalManager) {
			this.verticalManager = new VerticalManager();
		}
		const alaActual = this.listaAlasFormulario[this.numAla];
		if (!alaActual) {
			return
		}
		let idAlaActual = alaActual.Id;
		this.setRadius(alaActual.IconoContenidoScale);

		const alaFormularioSeleccionada = that.listaAlasFormulario.filter( a => a.Id === idAlaActual)
		alaFormularioSeleccionada.forEach((element) => {
			const oAlaForm = new AlaFormulario(element.ENTIDAD);
			const alaEncontradaAux = alaFormularioSeleccionada.find(
				(a) => a.Id === oAlaForm.Id
			);
			if (!alaEncontradaAux) {
				alaFormularioSeleccionada.push(oAlaForm);
			}

			that.alasDrop.sort(function (a, b) {
				if (a.nivel === b.nivel) {
					return a.label.localeCompare(b.label);
				}
				return a.nivel - b.nivel;
			});
			element.ENTIDAD.SECCIONS.forEach((_sec) => {
				_seccionesFormat[_sec.Id] = {
					nombre: _sec.Nombre,
				};

				_sec.NODOS.forEach((_nod) => {
					// x sería el índice del elemento en el array de nodosDeLaConsulta
					let enc = false;
					let x = 0;
					const tam = that.nodosDeLaConsulta.length;
					while (x < tam && !enc) {
						if (_nod.Id === that.nodosDeLaConsulta[x].Nodo) {
							enc = true;
						} else {
							x = x + 1;
						}
					}
					if (enc) {
						const point = {
							id: _nod.Id,
							x: _nod.X,
							y: _nod.Y,
							value: that.nodosDeLaConsulta[x].Total,
						};
						that.puntos.push(point);
					}
				});
			});
		});
		that.puntos = Object.assign([], that.puntos);
		//that.onLoadSecciones.emit(_seccionesFormat);
	}

	getFirsAla() {
		if (this.alasDrop && this.alasDrop.length > 0) {
			return this.alasDrop[0].label;
		}
		return "";
	}

	getFirsModo() {
		return this.modosDrop[0].label;
	}

	animationDone(evento) {
		// console.log('--------------- EJECUTANDO animationDone');
		const alaSeleccionadaAux = this.listaAlasFormulario.find(
			(a) => a.RutaImagen === this.alas[this.numAla]
		);
		if (alaSeleccionadaAux.GEOCALIBRACION_ALA) {
			this.anchoMapa =
				alaSeleccionadaAux.GEOCALIBRACION_ALA !== undefined
					? alaSeleccionadaAux.GEOCALIBRACION_ALA.SVG_width
					: this.anchoMapa;
			this.altoMapa =
				alaSeleccionadaAux.GEOCALIBRACION_ALA !== undefined
					? alaSeleccionadaAux.GEOCALIBRACION_ALA.SVG_height
					: this.altoMapa;
		}

		if (this.direccion === 1) {
			if (this.estado === "left") {
				this.estado = "center";
			}

			if (this.estado === "right") {
				this.estado = "left";
				this.pathPlano = this.alas[this.numAla];
				//  this.addSecciones(this.numAla);
			}
		} else {
			if (this.estado === "right") {
				this.estado = "center";
			}

			if (this.estado === "left") {
				this.estado = "right";
				//  this.addSecciones(this.numAla);
				this.pathPlano = this.alas[this.numAla];
			}
		}
		this.cargaSecciones();
	}

	next(evento) {
		this.numAla++;
		if (this.numAla >= this.seccionesPre.length) {
			this.numAla = 0;
		}
		this.direccion = 1;
		this.estado = "right";
	}

	before(evento) {
		this.numAla--;
		if (this.numAla < 0) {
			this.numAla = this.seccionesPre.length - 1;
		}
		this.direccion = -1;
		this.estado = "left";
	}

	onSVGLoaded($event) {
		// console.log('*** Plano cargado ***');
		this.addSecciones(this.numAla);
	}

	cambiarPlanta(res) {
		//  console.log(res);
		this.direccion = this.numAla < res.value ? 1 : 0;
		this.estado = this.numAla < res.value ? "right" : "left";

		//  console.log(this.alas[res.value]);
		this.numAla = res.value;
		if (this.numAla >= this.seccionesPre.length) {
			this.numAla = 0;
		}
	}

	public cambiarTipo(res) {
		this.estado = "right";
		this.numTipo = res.value;
	}

	addSecciones(num) {
		// console.log('*** Add Secciones ***');
		if (this.seccionesPre.length <= num) {
			return;
		}

		const _seccs = [];
		this.seccionesPre[num].forEach((seccion) => {
			let color = this.pickHex(0);
			let nombre = seccion.Nombre; //  + '[' + seccion.Id + ']';
			if (this.seccionesHot && this.seccionesHot[seccion.Id]) {
				color = this.seccionesHot[seccion.Id].color;

				nombre +=
					" " +
					this.seccionesHot[seccion.Id].Total +
					" visitas (" +
					this.seccionesHot[seccion.Id].percentageAll +
					"%) ";
			}

			const seccionCoordenadasPoligono: Array<Array<number>> =
				!seccion.CoordenadasPoligono
					? null
					: JSON.parse(seccion.CoordenadasPoligono);
			const seccionPlano = new SeccionPlano(
				seccion.Id,
				nombre,
				seccionCoordenadasPoligono,
				1,
				1
			);
			seccionPlano.ENTIDAD = seccion;
			seccionPlano.fill = color;
			seccionPlano.stroke = color;
			seccionPlano.strokeWidth = "5";
			seccionPlano.hoverFill = color;
			seccionPlano.hoverStroke = color;
			_seccs.push(seccionPlano);
		});
		this.secciones = _seccs;
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/graficas/hotChart/hotChart.component.ts